<template>
    <div class="random-message" :key="renderId">
        <div class="header-content">
            <span class="label">Variants</span>
            <div class="numbers">
                <div
                    v-for="(_, textIndex) in texts"
                    class="number"
                    :class="{ active: textIndex === currentIndex }"
                    :key="'number-' + textIndex"
                    @click="currentIndex = textIndex"
                >
                    {{ textIndex + 1 }}
                </div>
                <div class="number" @click="addNewMessage" v-if="!previewMode">+</div>
            </div>
        </div>

        <div class="message-content" :key="stateId + '-' + currentIndex">
            <button v-if="texts.length > 2 && !previewMode" class="control-button" @click="deleteMessage(currentIndex)">
                <md-icon class="text-primary">delete</md-icon>
            </button>
            <TiptapEditor
                :placeholder="$t('chatbotv2.enterBotResponseHere')"
                :show-attributes="showAttributes"
                :show-emoji="showEmoji"
                v-model="texts[currentIndex]"
                :key="stateId + '-' + currentIndex"
                :whatsapp-mode="whatsappMode"
                :allowed-attributes="allowedAttributes"
            />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../common/TiptapEditor";
import { generateRandomId } from "../../../../../../../utils/session";

const log = log2("RandomTextMessage");
export default {
    name: "RandomTextMessage",
    props: [
        "texts",
        "onUpdated",
        "showAttributes",
        "onAttributeAdded",
        "whatsappMode",
        "allowedAttributes",
        "showEmoji",
        "previewMode",
    ],
    components: { TiptapEditor },
    data() {
        return {
            items: this.texts,
            currentIndex: 0,
            stateId: 0,
            renderId: 0,
        };
    },
    methods: {
        deleteMessage(index) {
            log("deleteMessage", index);
            this.stateId++;
            if (this.currentIndex === index) {
                this.currentIndex = Math.max(0, index - 1);
            }
            const texts = this.items.splice(index, 1);
            this.onUpdated({ texts });
        },
        addAttribute(attributeName, textIndex) {
            log("addAttribute", { attributeName, textIndex });
            this.showAttr = null;
            const attrEl = `<span class="attribute-chip" data-attribute="${attributeName}" contenteditable="false">${attributeName}</span>`;
            this.items[textIndex] += attrEl;
        },
        addNewMessage() {
            log("addNewMessage");
            if (this.items.length < 10) {
                this.stateId++;
                this.items.push("");
                this.currentIndex = this.items.length - 1;
            }
        },
    },
    watch: {
        items(newValue) {
            log("watch items", newValue);
            this.onUpdated({ texts: newValue });
        },
        texts(newValue) {
            log("watch texts", newValue);
            if (!_.isEqual(newValue, this.items)) {
                this.currentIndex = 0;
                this.items = newValue;
            }
        },
        currentIndex(newValue) {
            this.renderId = _.uniqueId();
        },
    },
};
</script>

<style lang="scss" scoped>
.random-message {
    .control-button {
        align-items: center;
        background: #fff;
        border-radius: 100%;
        box-shadow: 0 1px 4px 0 rgb(0 0 0 / 19%);
        cursor: pointer;
        display: flex;
        height: 28px;
        justify-content: center;
        margin-bottom: 7px;
        transition: background-color 0.3s;
        width: 28px;
        position: absolute;
        right: -11px;
        top: -11px;
        border: none;
        z-index: 9;

        &:hover {
            border: 1px solid #006cff !important;
        }
    }

    .header-content {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .message-content {
        position: relative;
    }

    .label {
        color: #475e7a;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        margin-right: 12px;
    }

    .numbers {
        display: flex;
        gap: 2px;

        .number {
            box-shadow: 0 2px 6px 0 rgb(0 0 0 / 14%);
            align-items: center;
            background-color: #fff;
            border-radius: 100%;
            color: #475e7a;
            cursor: pointer;
            display: flex;
            flex-shrink: 0;
            font-size: 16px;
            font-weight: 600;
            height: 24px;
            justify-content: center;
            line-height: 20px;
            margin-bottom: 8px;
            margin-right: 8px;
            padding-bottom: 1px;
            width: 24px;

            &.active {
                background: #006cff;
                color: #fff;
            }
        }
    }
}
</style>

<style></style>
